import { PRIORITY_LABELS } from 'modules/shared/constants';
import { splitMinutes, splitMinutesFromTimeString } from 'modules/shared/utils';
import { TASK_TYPE_LABEL } from '../../constants';

function formatTimeString(hours, minutes) {
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

/**
 * Maps task assignment form payload to API JobAssignment payload
 */
export function mapAssignmentToApi({ task, projectData, values }) {
  const { employeeId, priority, note, inwardDocuments, assignedTasks, isoWeek } = values || {};

  return {
    job_id: projectData.id,
    department: TASK_TYPE_LABEL[task.type],
    documents_shared: inwardDocuments ?? [],
    note: note ?? '',

    employee_id: employeeId,
    priority: PRIORITY_LABELS[priority],

    tasks: assignedTasks.map((t) => {
      const { hours, minutes } = splitMinutes(t.minutes);

      return {
        name: t.taskName,
        alloted_time: formatTimeString(hours ?? 0, minutes ?? 0),
        assigned_week: isoWeek.week,
      };
    }),
  };
}

/**
 * Maps task edit assignment form payload to API JobAssignment payload
 */
export function mapEditAssignmentToApi({ values, task, assignedTask }) {
  const { priority, note, inwardDocuments } = values || {};

  const { hours, minutes } = splitMinutesFromTimeString(assignedTask.allottedTime);

  return {
    documents_shared: inwardDocuments ?? [],
    note: note ?? '',
    priority: PRIORITY_LABELS[priority],
    employee_id: assignedTask.employee?.id ?? null,
    alloted_time: formatTimeString(hours ?? 0, minutes ?? 0),
    assigned_week: assignedTask.assignedWeek,
    department: TASK_TYPE_LABEL[task.type],
  };
}
